import React, { PureComponent } from 'react';

import { PropTypes } from 'prop-types';

import FormContext from './FormContext';

export default class FormSubmit extends PureComponent {
  static Context = FormContext;

  static propTypes = {
    children: PropTypes.object
  };

  render() {
    const { children } = this.props;
    const { props } = children;

    return (
      <FormContext.Consumer>
        {(context) =>
          React.cloneElement(children, {
            onSubmit: context.submit,
            onSubmitAndReturn: context.submitAndReturn,
            isDisabled: context.isFormDisabled,
            ...props
          })
        }
      </FormContext.Consumer>
    );
  }
}
